import React from "react";
import styled, { css } from "styled-components";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader, IfPermitted } from "components/common";
import CollectionsList from "collections/components/CollectionsList";
import CreateCollectionButton from "collections/components/CreateCollectionButton";
import HelpPopoverButton from "components/common/HelpPopoverButton";
const StyledBulletList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.md};
    margin-bottom: ${theme.spacings.xs};
    margin-left: ${theme.spacings.xs};
  `
);
const StyledInfoList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    margin-bottom: ${theme.spacings.xs};
    margin-left: ${theme.spacings.xs};
    list-style-type: none;
  `
);
const StyledHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
  `
);
const CollectionsPage = () => /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Collections" }, /* @__PURE__ */ React.createElement(
  PageHeader,
  {
    title: /* @__PURE__ */ React.createElement(StyledHeader, null, /* @__PURE__ */ React.createElement("span", null, "Collections"), /* @__PURE__ */ React.createElement(
      HelpPopoverButton,
      {
        bsSize: "small",
        helpText: /* @__PURE__ */ React.createElement(StyledBulletList, null, /* @__PURE__ */ React.createElement("li", null, "Sharing Collection Content with a user grants them permission to the sharable entities within."), /* @__PURE__ */ React.createElement("li", null, "Removing the sharing of a Collection from a user also retracts any permissions granted by the Collection to that user."), /* @__PURE__ */ React.createElement("li", null, "A sharable entity such as a stream, dashboard or event may be added to a Collection as an action on that entity on the corresponding page (with the given examples, on the pages Streams, Dashboards, Alerts > Event Definitions)."), /* @__PURE__ */ React.createElement("li", null, "To modify the contents of a Collection, and the level of access the Collection grants, a user must be granted permission to Manage that Collection."), /* @__PURE__ */ React.createElement("li", null, "Only Administrators may add shared entities they do not own to Collections."), /* @__PURE__ */ React.createElement("li", null, "A team may have one or more Collections set as a Default Collection. Where this is set, any sharable entity that user creates is automatically added to those Collections."), /* @__PURE__ */ React.createElement("li", null, "Use Collections to ease permission management of sharable entities that have a specific grouping, such as a department, region, or business unit."))
      }
    )),
    topActions: /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "collections:create" }, /* @__PURE__ */ React.createElement(CreateCollectionButton, { bsStyle: "primary", buttonText: "Create" }))
  },
  /* @__PURE__ */ React.createElement(StyledInfoList, null, /* @__PURE__ */ React.createElement("li", null, "Collections are a tool to assist the management of content sharing."), /* @__PURE__ */ React.createElement("li", null, "A Collection is a grouping of sharable entities, such as streams, dashboards and events."), /* @__PURE__ */ React.createElement("li", null, "The content of a Collection can be quickly shared with a User or Team to grant permissions to sharable entities in bulk."))
), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(CollectionsList, null))));
export default CollectionsPage;
